import React from "react";
import { Spinner } from "react-bootstrap";

/**
 * Overlay de chargement semi-transparent (modal, board, zone de contenu).
 */
const LoadingOverlay = ({ show, message = "Chargement…", minHeight = 120 }) => {
  if (!show) {
    return null;
  }
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-muted"
      style={{
        position: "absolute",
        inset: 0,
        background: "rgba(255, 255, 255, 0.85)",
        zIndex: 10,
        minHeight,
        borderRadius: 4,
      }}
    >
      <Spinner animation="border" variant="success" role="status" />
      <span className="mt-2 small">{message}</span>
    </div>
  );
};

export default LoadingOverlay;
